import gql from 'graphql-tag';

export const minimumAssessmentsData = gql`
  query allAvailableAssessments($dexCourseId: Float!) {
    allAvailableAssessments(dexCourseId: $dexCourseId) {
      id
      title
      daysToRetry
      assessmentType
      assessmentStatusByUser
      assessmentResultsByUser {
        id
        createdAt
        gradingDate
        status
      }
      currentRelatedCourse {
        isAvailable
      }
      minimumContractDays
      daysUntilAvailable
      category {
        name
      }
    }
  }
`;

export const assessmentResultsData = gql`
  query assessmentResultsByUser($assessmentId: Float!, $dexCourseId: Float!) {
    getAssessmentById(id: $assessmentId, dexCourseId: $dexCourseId) {
      title
      assessmentType
      passingGradePercentage
      category {
        name
      }
      assessmentResultsByUser {
        grade
        gradingDate
        lastReply {
          feedbackText
        }
        evaluationSheet {
          presentationGrade
          adherenceGrade
          contextualizationGrade
          problematizationGrade
          solutionGrade
          isPlagiarism
        }
      }
    }
  }
`;

export const assessmentModuleOneData = gql`
  query getModuleOneData($assessmentId: Float!, $dexCourseId: Float!) {
    getAssessmentById(id: $assessmentId, dexCourseId: $dexCourseId) {
      id
      title
      category {
        name
      }
      passingGradePercentage
      currentVariantByUser {
        dexExamGroupId
        link
        id
      }
    }
  }
`;

export const assessmentModuleVariantLink = gql`
  query assessmentModuleOneVariantLink($assessmentId: Float!, $dexCourseId: Float!) {
    getAssessmentById(id: $assessmentId, dexCourseId: $dexCourseId) {
      currentVariantByUser {
        link
      }
    }
  }
`;

export const assessmentModuleTwoData = gql`
  query getModuleTwoData($assessmentId: Float!, $dexCourseId: Float!) {
    getAssessmentById(id: $assessmentId, dexCourseId: $dexCourseId) {
      id
      title
      instructions
      currentVariantByUser {
        id
        link
        title
      }
      category {
        name
      }
    }
  }
`;

export const assessmentTCCData = gql`
  query getAssessmentTCCData($assessmentId: Float!, $dexCourseId: Float!) {
    getAssessmentById(id: $assessmentId, dexCourseId: $dexCourseId) {
      id
      category {
        name
      }
      assessmentResultsByUser {
        id
        grade
        status
        replies {
          type
          status
          answer
          feedbackText
          link
          feedbackLink
        }
        lastReply {
          type
          link
          status
          answer
          feedbackText
        }
        evaluationSheet {
          contentGrade
          clarityGrade
          structureGrade
          discourseGrade
          adherenceGrade
          innovationGrade
          originalityGrade
          formatRulesGrade
          upToDatenessGrade
          contextualizationGrade
          isPlagiarism
        }
        maxPartialTCCSubmissions
      }
    }
  }
`;
